const mapContactCentersResult = ({ data, totalCount }) => {
	const mappedData = data.map((item) => {
		return {
			id: item.id,
			name: item.name,
			item,
		}
	});
	return {
		data: mappedData,
		total: totalCount
	};
};

export {
	mapContactCentersResult
};
